<template>
<div id="apptable" v-cloak>

    <b-card header="Abbonamenti" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-4">
                    <b-button variant="warning" v-on:click="tipologie()">
                        Tipologie Abbonamenti
                    </b-button>
                </div>
                <div class="col-md-5 text-right">
                    <b-button size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="tipoVis" scope="row">{{row.value}}</template>
                <template slot="socioVis" scope="row">{{row.value}}</template>
                <template slot="datainizio" scope="row">{{row.value | formatDate}}</template>
                <template slot="datafine" scope="row">{{row.value | formatDate}}</template>
                <template slot="importo" scope="row">{{row.value}}</template>
                <template slot="note" scope="row">{{row.value}}</template> <!-- è volutamente non filtrato e accorciato -->
                <template slot="datafinebloccopreno" scope="row">{{row.value | formatDate}}</template>  
                <template slot="attivoVis" scope="row">{{row.value}}</template>                

                <template slot="modifica" scope="row">
                    <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                    <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>
                </template>
            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

</div>
</template>

<script>
import moment from 'moment'

import {
    ctrlVismenu
} from '../util.js'

import {
    NAMESPACE
} from '../config.js'

export default {
    name: 'apptable',
    data: function () {
        return {            
            items: [],
            id_socio: this.$route.params.id_socio || null,
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                tipoVis: {
                    label: 'Tipo',
                    sortable: true
                },
                socioVis: {
                    label: 'Socio',
                    sortable: true
                },
                datainizio: {
                    label: 'Data inizio',
                    sortable: true
                },
                datafine: {
                    label: 'Data fine',
                    sortable: true
                },
                importo: {
                    label: 'Importo €',
                    sortable: true
                },
                note: {
                    label: 'Note',
                    sortable: true
                },
                datafinebloccopreno: {
                    label: 'Data fine blocco prenotazione',
                    sortable: true
                },
                attivoVis: {
                    label: 'Attivo',
                    sortable: true
                },
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,           
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    filters: {
        formatDate: function(value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY')
        }
    },
    methods: {
        insert() {
            if((this.id_socio || '') != ''){
                this.$router.push('/app/dettaglioabbonamento/id_socio/' + this.id_socio); 
            }
            else{
                this.$router.push('/app/dettaglioabbonamento');
            }
        },
        details(item, index, button) {
            this.$router.push({
                path: `/app/dettaglioabbonamento/${item.id}`
            });
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        tipologie() {

            this.$router.push({
               path: `/app/tipiabbonamento/`
            });

        }      
    },
    created: function () {

        if(!ctrlVismenu("A")){
            this.$router.replace('/accessdenied');
            return;
        }

        var token = localStorage.getItem('token');
        this.axios.get(NAMESPACE + 'rest/abbonamenti/id_socio/' + this.id_socio, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;
                        let apptable = this;

                        this.items.forEach(function (element, index) {
                            element.tipoVis = element.descrizionetipo;
                            element.socioVis = element.cognomesocio + ' ' + element.nomesocio;
                            element.attivoVis = (element.flagatt == 'S' ? 'Sì' : 'No');
                            var today = moment(String(new Date())).format('YYYY-MM-DD');
                            if (element.flagatt != 'S' || 
                                !(element.datainizio <= today && today <= element.datafine)
                               ) {
                                element._rowVariant = 'danger';
                            }
                            else if(element.flagatt == 'S' && today <= element.datafinebloccopreno){
                                element._rowVariant = 'warning';
                            }

                            delete element.uteins; //per motivi di ricerca
                        });

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    }
}
</script>
